import { render, staticRenderFns } from "./donor-my-teams.vue?vue&type=template&id=27c06625&scoped=true&"
import script from "./donor-my-teams.vue?vue&type=script&lang=js&"
export * from "./donor-my-teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c06625",
  null
  
)

export default component.exports